import * as React from 'react';
import {
	CheckboxGroup,
	FormCheckConditional,
	TextInput,
	Label
} from '../../../../../components/forms';
import handleNoneOptionAndValidationHOC from '../handleNoneOptionAndValidationHOC';
import NextPreviousButtons from '../../NextPreviousButtons';

interface Props {
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (value?: {}) => void;
	onQuestionnaireChange: (value?: {}) => void;
	nextStep: (e: any) => void;
	prevStep: (e: any) => void;
}
interface Props {
	questionnaire: any;
	onQuestionnaireBlur: (value?: {}) => void;
	onQuestionnaireChange: (value?: {}) => void;
}
const NeurologicalQuestion: React.StatelessComponent<Props> = props => {
	const isNextDisabled = function () {
		return !props.questionnaire[questionName].isValid;
	};
	return (
		<div className="form-group mb-0">
			<Label>{props.questions[questionName]}</Label>
			<div className="section-base section-bordered mt-1 form-group">
				<CheckboxGroup
					title="Neurological disorders, including:"
					className="mb-2"
					checkOptions={[
						{
							name: 'epilepsy',
							label: 'Epilepsy or seizures with any episodes within the past 12 months',
							checked: props.questionnaire[questionName].epilepsy,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'tremor',
							label: 'Tremor',
							checked: props.questionnaire[questionName].tremor,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'huntingtonsDisease',
							label: `Huntington's disease`,
							checked: props.questionnaire[questionName].huntingtonsDisease,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'brainAneurysm',
							label: 'Brain aneurysm',
							checked: props.questionnaire[questionName].brainAneurysm,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'tia',
							label: 'Transient ischemic attack (TIA)',
							checked: props.questionnaire[questionName].tia,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'stroke',
							label: 'Stroke',
							checked: props.questionnaire[questionName].stroke,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'parkinsonsDisease',
							label: `Parkinson's disease`,
							checked: props.questionnaire[questionName].parkinsonsDisease,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'als',
							label: `Motor neuron disease (Lou Gehrig's disease or ALS)`,
							checked: props.questionnaire[questionName].als,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'alzheimersDisease',
							label: `Alzheimer's disease`,
							checked: props.questionnaire[questionName].alzheimersDisease,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'cognitiveImpairment',
							label: 'Cognitive impairment',
							checked: props.questionnaire[questionName].cognitiveImpairment,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'dementia',
							label: 'Dementia',
							checked: props.questionnaire[questionName].dementia,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'multipleSclerosis',
							label: 'Multiple sclerosis',
							checked: props.questionnaire[questionName].multipleSclerosis,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'muscularDystrophy',
							label: 'Muscular dystrophy',
							checked: props.questionnaire[questionName].muscularDystrophy,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'lossOfBalance',
							label: 'Loss of balance',
							checked: props.questionnaire[questionName].lossOfBalance,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'lossOfSpeech',
							label: 'Loss of speech',
							checked: props.questionnaire[questionName].lossOfSpeech,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'cerebralPalsy',
							label: 'Cerebral palsy',
							checked: props.questionnaire[questionName].cerebralPalsy,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'downSyndrome',
							label: 'Down syndrome',
							checked: props.questionnaire[questionName].downSyndrome,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'autism',
							label: 'Autism',
							checked: props.questionnaire[questionName].autism,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'developmentalDisorder',
							label: 'Developmental disorder',
							checked: props.questionnaire[questionName].developmentalDisorder,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'muscleWeakness',
							label: 'Muscle weakness, tingling, or numbness of the extremities',
							checked: props.questionnaire[questionName].muscleWeakness,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'neurologicalDisorderOther',
							label: 'Other',
							checked: props.questionnaire[questionName].neurologicalDisorderOther,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange,
							conditionalChildren: (
								<FormCheckConditional isOpen={props.questionnaire[questionName].neurologicalDisorderOther}>
									<TextInput
										labelText="Please specify:"
										name="neurologicalDisorderOtherDetails"
										onBlur={props.onQuestionnaireBlur}
										onChange={props.onQuestionnaireChange}
										value={props.questionnaire[questionName].neurologicalDisorderOtherDetails}
										className="mb-2"
									/>
								</FormCheckConditional>
							)
						},
						{
							name: 'neurologicalNone',
							label: 'None of the above apply to me',
							checked: props.questionnaire[questionName].neurologicalNone,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange,
							className: 'border-top pt-2'
						},
					]}
				/>
			</div>
			<NextPreviousButtons nextStep={props.nextStep} prevStep={props.prevStep} isNextDisabled={isNextDisabled} />
		</div>
	);
};

const questionName = 'neurological';
const hocConfig = {
	questionName: questionName,
	otherName: 'neurologicalDisorderOther',
	otherDetailsName: 'neurologicalDisorderOtherDetails'
};
export default handleNoneOptionAndValidationHOC(NeurologicalQuestion, hocConfig);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/medicalQuestions/medicalQuestion1/NeurologicalQuestion.tsx